import { toKenyanMobile } from '@chukua/common';

/** A Kenyan mobile the way people write it, 0712 345 678, however it was stored or typed; anything else as it came. */
export function localMobile(phone: string): string {
  const e164 = toKenyanMobile(phone);
  if (!e164) return phone;
  const national = `0${e164.slice(4)}`;
  return `${national.slice(0, 4)} ${national.slice(4, 7)} ${national.slice(7)}`;
}
